import { useSiteMonitoringContext } from '@components/StoreMonitoring/SiteMonitoringContext'
import { Select } from 'antd'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useState } from 'react'
const { Option } = Select
export function CustomSearchBar({ gridApiRef = null, onSelect = () => {} }) {
  const [inputValue, setInputValue] = useState('')
  const { data, setFilteredStores, setCustomSelectedStores, customSelectedStores } = useSiteMonitoringContext()
  const onChange = (value, items) => {
    // on selection changed, not search value
    if (!value.length) return onClear()
    const rows = data?.stores?.filter((store) => value.includes(store?.id))
    setFilteredStores(rows)
    if (rows) {
      if (onSelect) onSelect(rows)
      gridApiRef?.current?.setFilterModel({
        store_number: { filterType: 'set', values: rows.map((store) => store.store_number) },
      })
    }

    const fixedItems = rows.map((store) => ({ value: store.id, label: store.store_number }))
    setCustomSelectedStores(fixedItems)
  }

  const onClear = () => {
    setInputValue('')
    gridApiRef?.current?.setFilterModel({ store_number: null })
    gridApiRef?.current.onFilterChanged()
    setCustomSelectedStores([])
  }

  const handleFilterOption = (input, option) => {
    return (option?.label ? option.label.toLowerCase() : '').includes(input?.toLowerCase())
  }
  const handleFilterSort = (optionA, optionB) => {
    if (inputValue) {
      const matchA = optionA.label?.split(' ')[0].includes(inputValue)
      const matchB = optionB.label?.split(' ')[0].includes(inputValue)
      if (matchA && !matchB) return -1
      if (!matchA && matchB) return 1
      if (matchA && matchB) return parseInt(optionA?.label ?? '0') - parseInt(optionB?.label ?? '0')
    }
    return parseInt(optionA?.label ?? '0') - parseInt(optionB?.label ?? '0')
  }

  return (
    <Select
      allowClear
      value={customSelectedStores}
      defaultValue={customSelectedStores}
      className='custom-search-bar full-height-width'
      mode={'multiple'}
      showSearch
      onSearch={(value) => setInputValue(value)}
      onChange={onChange}
      placeholder={'Search Sites'}
      filterOption={handleFilterOption}
      filterSort={handleFilterSort}
      optionLabelProp={'label'}
    >
      {data?.stores?.map((store) => {
        const label = `${store?.store_number} ${store?.name} ${store.site_counterparty} ${store?.address} ${store?.city} ${store?.state}`
        return (
          <Option key={store?.id} value={store.id} label={label}>
            <Horizontal alignItems={'center'} justifyContent={'start'}>
              <Vertical flex={1}>
                <Horizontal justifyContent={'space-between'} alignItems={'end'}>
                  <Texto category={'p2'} weight={'bold'}>
                    {store.store_number}
                  </Texto>
                  <Texto category={'p2'} weight={'bold'}>
                    {store.address}
                  </Texto>
                </Horizontal>
                <Horizontal
                  justifyContent={'space-between'}
                  alignItems={'start'}
                  style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                >
                  <Texto style={{ color: 'var(--gray-600)' }}>
                    {store.name} ({store.site_counterparty})
                  </Texto>
                  <Texto style={{ color: 'var(--gray-600)' }} align={'right'}>
                    {store.city}, {store.state}
                  </Texto>
                </Horizontal>
              </Vertical>
            </Horizontal>
          </Option>
        )
      })}
    </Select>
  )
}
